import { useContext, useEffect, useRef, useState } from 'react';
import {useNavigate} from 'react-router-dom'
import PayContext from '../../context/PayContext';
import UserContext from '../../context/UserContext';
import NewAddressForm from '../../components/NewAddressForm';
import '../../styles/payment.scss';
import Map from '../../components/map/Map';
import LoactionContext from '../../context/LocationContext';
import Confirm from '../../components/Confirm';
import axios from 'axios';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit.svg';
import { ReactComponent as AddIcon } from '../../assets/icons/add.svg';

const Payment = () => {
  const navigate = useNavigate()
  const { paymentData } = useContext(PayContext);
  const { user, setUser } = useContext(UserContext);
  const { locationData, setLocationData, setUpdate } = useContext(LoactionContext);
  const [active, setActive] = useState(false);
  const [addressesOpen, setAddressesOpen] = useState(false);
  const [payMode, setPaymode] = useState('normal');
  const [isOnline, setIsOnline] = useState(true);
  const [confirm, setConfirm] = useState(false);
  const [walletUse,setWalletUse]=useState(true);
  const editData = useRef(null);
  const descRef = useRef(null);
  const walletRef = useRef(null);

  function toFarsiNumber(n) {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    return parseInt(n)
      .toLocaleString()
      .toString()
      .replace(/\d/g, (x) => farsiDigits[x]);
  }

  const deactive = (mode) => {
    setActive(mode);
  };

  const addNewAdressHandler = () => {
    editData.current = null;
    setActive((prev) => !prev);
  };

  const EditAdressHandler = () => {
    setActive((prev) => !prev);
    editData.current = locationData.defLocationData;
  };

  const deleteAddress = () => {
    const fetcher = async () => {
      try {
        await fetch(
          `https://hamrahyper.ir/api/user/addresses/${locationData.defLocationData.id}`,
          {
            method: 'DELETE',
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
                .content,
            },
          }
        );

        setConfirm(false);
        setUpdate((prev) => !prev);
        setActive(false);
      } catch (error) {
        console.log(error);
      }
    };
    fetcher();
  };

  const walletChecker = (e) => {
    console.log(paymentData.wallet+"|"+walletUse+"|"+e.target.checked);
    if (paymentData.wallet > 0) {
      setWalletUse(e.target.checked);
    }
  };

  const finalPayment = () => {
    // Pay mode //
    const payMethod = isOnline ? 'online' : 'direct';

    // Total price + send price
    const totalPriceSendPrice =
      paymentData.totalPrice +
      paymentData[payMode === 'normal' ? 'normalPrice' : 'specialPrice'];

    const totalPrice = walletUse
      ? totalPriceSendPrice - paymentData.wallet
      : totalPriceSendPrice;
    // Cart
    const cart = JSON.parse(localStorage.getItem('products')).map((item) => {
      return { id: item.id, count: item.count };
    });
    // Pid
    const pid = '111111';
    // Off code
    const offcode = '';
    // description
    const description = descRef.current.value;
    // Offiliation Id
    const affiliation_id = user.data.affiliation_id;
    // Wallet
    const wallet = walletUse ? paymentData.wallet.toString() : '0';
    // Address
    const address = locationData.defLocationData;
    // Ride type
    const rideType = payMode;

    const formData = new FormData();
    formData.append('receiver', address.receiver);
    formData.append('address', address.address);
    formData.append('phone', address.phone);
    formData.append('postcode', address.postcode);
    formData.append('lat', address.latitude.toString());
    formData.append('lng', address.longitude.toString());
    formData.append('rideType', rideType);
    formData.append('payMethod', payMethod);
    formData.append('totalPrice', totalPrice.toString());
    formData.append('cart', JSON.stringify(cart));
    formData.append('pid', pid);
    formData.append('offcode', offcode);
    formData.append('description', description);
    formData.append('byaffiliation', affiliation_id);
    formData.append('wallet', wallet);

    const fetcher = async () => {
      const res = await axios({
        method: 'post',
        url: '/api/orders',
        data: formData,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')
            .content,
        },
      });

      //console.log(res);

      if(payMethod === 'online' && res?.status === 200 && res?.data?.status === 'OK') {
        if(walletUse)
          window.open(`https://hamrahyper.ir/pay/${res.data.transaction_id}/1`, '_blank');
        else {
          window.open(`https://hamrahyper.ir/pay/${res.data.transaction_id}/0`, '_blank');
        }
      } else {
        setUser(prev => ({...prev, payData: res.data}))
        navigate('/success')
      }
    };

    fetcher();
  };

  useEffect(() => {
    window && window.scrollTo(0, 0);

    const closest = (e) => {
      if (
        !e.target.closest('.address') ||
        !e.target.classList.contains('addresses_activer')
      ) {
        setAddressesOpen(false);
      }
    };

    window.addEventListener('click', closest);

    return () => {
      window.removeEventListener('click', closest);
    };
  }, [active]);

  // Force to use wallet
  useEffect(() => {
    if (walletRef?.current) {
      if (paymentData.wallet < 0) {
        walletRef.current.classList.add('lock');
        walletRef.current.querySelector('#wallet').checked = true;
        setWalletUse(true);
      } else {
        walletRef.current.classList.remove('lock');
      }
    }

    setActive(false);
  }, [locationData, paymentData?.wallet,isOnline]);

  if (!paymentData || !paymentData.special) {
    return (
      <h2 className='bg-red-600 text-white text-5xl p-5 rounded-xl my-auto'>
        لطفا اول صفحه سبد خرید را کامل کنید
      </h2>
    );
  }

  return (
    <div className='w-full flex flex-col justify-between items-center gap-5 p-5 sm:px-20 bg-slate-100'>
      {console.log(paymentData)}
      <NewAddressForm
        active={active}
        editData={editData.current}
        callBack={deactive}
      />
      <Confirm
        message={'این آدرس حذف شود؟'}
        show={confirm}
        callBack={(res) => (res ? deleteAddress() : setConfirm(false))}
      />

      <div className='w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400'>
        <div className='w-full flex justify-between items-center text-right border-b border-gray-500 pb-4'>
          {window.innerWidth < 500 ? (
            <>
              <AddIcon
                className='add-new-address w-5 h-5'
                onClick={addNewAdressHandler} />
              <EditIcon
                className='add-new-address w-5 h-5 ml-3'
                onClick={EditAdressHandler} />
              <DeleteIcon
                className='add-new-address w-5 h-5 mr-auto ml-3'
                style={{width: '1.1rem', height: '1.1rem'}}
                onClick={() => {
                  setConfirm(true);
                }} />
            </>
          ) : (
            <>
              <button
                className='add-new-address p-2 px-4 rounded-xl bg-slate-700 text-white'
                onClick={addNewAdressHandler}>
                افزودن آدرس جدید
              </button>
              <button
                className='add-new-address p-2 px-4 rounded-xl bg-slate-700 text-white ml-5'
                onClick={EditAdressHandler}>
                ویرایش
              </button>
              <button
                className='add-new-address p-2 px-4 rounded-xl bg-slate-700 text-white mr-auto ml-5'
                onClick={() => {
                  setConfirm(true);
                }}>
                حذف
              </button>
            </>
          )}

          <h3 className='font-bold'>انتخاب آدرس</h3>
        </div>

        <div className='w-full h-fit flex flex-col-reverse sm:flex-row justify-between items-center'>
          {locationData && (
            <Map
              location={[
                locationData.defLocationData.latitude,
                locationData.defLocationData.longitude,
              ]}
            />
          )}

          <div className='w-full flex flex-col justify-between items-end gap-2 pt-4'>
            <div className='flex justify-center items-center gap-2'>
              <span>
                {locationData && locationData.defLocationData.receiver}
              </span>
              <h4 className='font-bold'>:نام گیرنده</h4>
            </div>

            <div className='flex justify-center items-center gap-2'>
              <span>{locationData && locationData.defLocationData.phone}</span>
              <h4 className='font-bold'>:تلفن</h4>
            </div>

            <div className='flex justify-center items-center gap-2'>
              <span>
                {locationData && locationData.defLocationData.postcode}
              </span>
              <h4 className='font-bold'>:کد پستی</h4>
            </div>

            <div className='flex justify-center items-center gap-2'>
              <span>
                {locationData && locationData.defLocationData.address}
              </span>
              <h4 className='font-bold'>:آدرس</h4>
            </div>

            <div
              className={`w-full flex flex-col justify-center items-end gap-2 address z-10 ${
                addressesOpen ? 'open' : ''
              }`}>
              <button
                className='addresses_activer text-right bg-slate-700 text-white p-2 rounded-t-xl'
                onClick={() => setAddressesOpen((prev) => !prev)}>
                سایر آدرس ها
              </button>
              <ul className='addresses_item w-full transition-all'>
                {console.log(locationData)}
                {locationData &&
                  locationData.data.map((item) => (
                    <li
                      key={item.id}
                      className='w-full bg-slate-700 text-white p-2 text-right hover:bg-slate-600 cursor-pointer'
                      onClick={() => {
                        setLocationData((prev) => ({
                          ...prev,
                          defLocationData: item,
                        }));
                        setAddressesOpen(false);
                      }}>
                      {item.address}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='w-full flex flex-col items-end gap-3 p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400'>
        <h3 className='w-full text-right border-b border-gray-500 pb-4 font-bold'>
          شیوه ارسال سفارش
        </h3>

        <div className='w-full flex flex-col sm:flex-row justify-between gap-2'>
          <div
            data-paymode={payMode === 'normal'}
            onClick={() => setPaymode('normal')}
            className='w-full flex flex-col justify-between gap-5 items-end p-5 shadow-md rounded-lg border cursor-pointer'>
            <span>پیک معمولی</span>

            <div className='flex flex-col justify-between items-end gap-2 w-full'>
              <div className='flex justify-between items-center gap-1 w-fit m-auto'>
                <span>{paymentData.normaltext}</span>
                <span>:زمان تقریبی تحویل</span>
              </div>

              <div className='flex justify-end items-center gap-1 w-fit m-auto'>
                <span>تومان</span>
                <span>{toFarsiNumber(paymentData.normalPrice)}</span>
              </div>
            </div>
          </div>

          <div
            data-paymode={payMode === 'special'}
            onClick={() => setPaymode('special')}
            className='w-full flex flex-col justify-between gap-5 items-end p-5 shadow-md rounded-lg border cursor-pointer text-right'>
            <span>پیک ویژه</span>

            <div className='flex flex-col justify-between items-end gap-2 w-full'>
              <div className='flex justify-between items-center gap-1 text-right w-fit m-auto'>
                <span>{paymentData.specialtext}</span>
                <span> :زمان تقریبی تحویل</span>
              </div>

              <div className='flex justify-end items-center gap-1 text-right w-fit m-auto'>
                <span>تومان</span>
                <span>{toFarsiNumber(paymentData.specialPrice)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='w-full flex justify-between items-stretch gap-5'>
        {/* <div className="w-full p-5 bg-slate-300 rounded-sm shadow-sm shadow-slate-400">
          <h3 className="w-full text-right border-b border-gray-500 pb-4">
            صدور فاکتور
          </h3>

          <div className="flex py-4 justify-end items-center gap-1">
            <label htmlFor="factor">فاکتور</label>
            <input
              type="checkbox"
              name="factor"
              id="factor"
              defaultChecked
              className="w-5 h-5"
              ref={factor}
            />
          </div>
        </div> */}
        <div className='w-full p-5 bg-slate-300 rounded-sm shadow-sm shadow-slate-400'>
          <h3 className='w-full text-right border-b border-gray-500 pb-4 font-bold'>
            نوع پرداخت
          </h3>

          <fieldset className='flex py-4 m-auto w-fit justify-between items-end gap-7'>
            <div className='w-fit flex justify-end items-center gap-1'>
              <label htmlFor='online'>آنلاین</label>
              <input
                type='radio'
                id='online'
                name='pay'
                value='online'
                defaultChecked
                className='w-5 h-5'
                onClick={() => setIsOnline(true)}
              />
            </div>

            <div className='w-fit flex justify-end items-center gap-1'>
              <label htmlFor='ofline'>درب منزل</label>
              <input
                type='radio'
                id='ofline'
                name='pay'
                value='ofline'
                className='w-5 h-5'
                onClick={() =>  setIsOnline(false)}
              />
            </div>
          </fieldset>
        </div>
      </div>

      {(isOnline) && (
        <div className='w-full flex flex-col items-end gap-3 p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400'>
          <h3 className='w-full text-right border-b border-gray-500 pb-4 font-bold'>
            کیف پول
          </h3>

          <div
            className='w-full flex flex-col-reverse items-end justify-center sm:flex-row sm:items-center gap-2'
            ref={walletRef}>
            <div className='mr-0 ml-auto sm:mr-auto sm:ml-0 flex justify-end items-center sm:justify-center gap-2'>
              <input
                type='checkbox'
                name='wallet'
                id='wallet'
                className='w-5 h-5'
                checked={walletUse}
                onClick={walletChecker}
              />
              <label htmlFor='wallet' className='select-none'>
                استفاده از کیف پول
              </label>
            </div>

            <div className='flex justify-end items-center gap-1'>
              <span>تومان</span>
              <span>{toFarsiNumber(paymentData.wallet)}</span>
            </div>
            <h4>:موجودی کیف پول</h4>
          </div>
        </div>
      )}

      <div className='w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400 gap-2'>
        <h3 className='w-full text-right border-b border-gray-500 pb-4 font-bold'>
          قیمت ها
        </h3>

        <div className='flex justify-between items-center gap-2 pt-2'>
          <div className='flex justify-between items-center gap-2'>
            <span>تومان</span>
            <span>{toFarsiNumber(paymentData.originalPrice)}</span>
          </div>

          <h2>:جمع سبد</h2>
        </div>

        <div className='flex justify-between items-center gap-2'>
          <div className='flex justify-between items-center gap-2'>
            <span>تومان</span>
            <span>{toFarsiNumber(paymentData.totalDiscount)}</span>
          </div>

          <h2>:تخفیف شما</h2>
        </div>

        <div className='flex justify-between items-center gap-2'>
          <div className='flex justify-between items-center gap-2'>
            <span>تومان</span>
            <span>{toFarsiNumber(paymentData[
                      payMode === 'normal' ? 'normalPrice' : 'specialPrice'
                    ])}</span>
          </div>

          <h2>:هزینه پیک</h2>
        </div>

        <div className='flex justify-between items-center gap-2 text-green-700 font-bold text-lg w-fit m-auto'>
          <div className='flex justify-between items-center gap-2'>
            <span>تومان</span>
            <span>
              {toFarsiNumber(
                Number(
                  paymentData.totalPrice +
                    paymentData[
                      payMode === 'normal' ? 'normalPrice' : 'specialPrice'
                    ] -
                    ((walletUse && isOnline) ? paymentData.wallet : 0)
                )
              )}
            </span>
          </div>

          <h3>:مبلغ قابل پرداخت</h3>
        </div>
      </div>

      <div className='w-full flex flex-col items-end p-5 bg-slate-300 rounded-lg shadow-sm shadow-slate-400 gap-2'>
        <h3 className='w-full text-right border-gray-500 pb-4 font-bold'>
          توضیحات
        </h3>

        <textarea
          className='w-full text-right p-3 rounded-lg focus:outline-gray-300'
          name='description'
          id=''
          cols='20'
          rows='5'
          ref={descRef}></textarea>
      </div>

      <div className='w-full flex justify-between items-center bg-slate-300 rounded-lg shadow-sm shadow-slate-400'>
        <button
          onClick={finalPayment}
          className='w-full h-full p-3 bg-green-600 border-tr rounded-tl-lg rounded-bl-lg text-white font-bold'>
          {isOnline ? 'پرداخت آنلاین' : 'تایید نهایی'}
        </button>
        <button className='w-full h-full p-3 rounded-tr-lg rounded-br-lg font-bold' onClick={()=>navigate('/cart')}>
          بازگشت به سبد خرید
        </button>
      </div>
    </div>
  );
};

export default Payment;
